<!-- 比赛设置tab -->
<template>
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules"  label-width="130px">  
        <el-row>
            <el-form-item label="赛事主题 ">
                <el-col class="red size18">{{ pubTitle }}</el-col>
            </el-form-item>
        </el-row>
        <el-row>
            <el-col :span="6">
                <el-form-item label="赛事类型">
                    <el-col class="red size16">{{ matchType }}</el-col>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="比赛轮数" prop="number">
                    <el-input type="number" v-model="ruleForm.number">
                        <template slot="append">轮</template>
                    </el-input>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
                <el-form-item label="每牌最大升级数" prop="maxNumber">
                    <el-input type="number" v-model="ruleForm.maxNumber"/>
                </el-form-item>
            </el-col> -->            
        </el-row>            
        <!-- <el-row>
            <el-col>
                <el-form-item label="比赛得分" prop="winScore"> 
                    <el-col :span="6">
                        <el-form-item prop="winScore"> 
                            <el-input type="number" v-model="ruleForm.winScore">
                                <template slot="prepend">胜</template>
                                <template slot="append">分</template>
                            </el-input>
                        </el-form-item>
                    </el-col>     
                    <el-col :span="1">&nbsp;</el-col>                   
                    <el-col :span="6">
                        <el-form-item prop="equalScore"> 
                        <el-input type="number" v-model="ruleForm.equalScore">
                            <template slot="prepend">平</template>
                            <template slot="append">分</template>
                        </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="1">&nbsp;</el-col>     
                    <el-col :span="6">
                        <el-form-item prop="loseScore"> 
                            <el-input type="number" v-model="ruleForm.loseScore">
                                <template slot="prepend">负</template>
                                <template slot="append">分</template>
                            </el-input>
                        </el-form-item>
                    </el-col>                                       
                </el-form-item>
            </el-col>
        </el-row>  
        <el-row>
            <el-col :span="8"> 
                <el-form-item label="倒扣级数" prop="grade">
                    <el-radio-group v-model="ruleForm.grade">
                        <el-radio label="是">是</el-radio>
                        <el-radio label="否">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="对方弃权级差得分" prop="gradeScore" class="grade-score">
                    <el-input type="number" v-model="ruleForm.gradeScore" style="width:130px"/>
                </el-form-item> 
            </el-col>              
            <el-col :span="6">
                <el-form-item label="升级数" prop="gradeNumber">
                    <el-input type="number" v-model="ruleForm.gradeNumber"/>
                </el-form-item>
            </el-col>               
        </el-row>-->
        <el-form-item label="排名方法" prop="rankList">
            <el-checkbox-group v-model="ruleForm.rankList" @change="selectRank">
                <el-checkbox :label="item.value"  v-for="item in  pubRankList" :key="item.label">
                {{ item.label }}
                </el-checkbox>
            </el-checkbox-group>
        </el-form-item>    
        <el-form-item label="已选排名">
            {{ rankListName }}
        </el-form-item>          
        <el-form-item label="同单位" prop="comeRule">
            <el-radio-group v-model="ruleForm.comeRule">
                <el-radio :label="item.value" v-for="item in  comeRuleList" :key="item.label">
                {{ item.label }}
                </el-radio>
            </el-radio-group>
        </el-form-item>
        <el-row>
            <el-col :span="8">
                <el-form-item label="团体排名">
                <el-select v-model="ruleForm.groupRank">
                    <el-option v-for="item in groupRankList" 
                    :key="item.value"
                    :label="item.label" 
                    :value="item.value" >{{ item.label }}
                    </el-option>
                </el-select>
            </el-form-item>
            </el-col>
        </el-row>  
        <el-form-item>
            <el-button type="primary" @click="submit('ruleForm')" style="width:220px">提交</el-button>
            <el-row class="red">温馨提示：
                比赛设置提交后， 小程序不可自主报名，只能网页选手界面添加；</el-row>   
            <el-row class="red">如需要选手自助报名，请在已发布赛事中清除成绩，状态改为比赛报名中。</el-row>     
        </el-form-item> 
    </el-form>
</template>

<script>
export default {
    props:{
        pubId: {
            type: String,
            default: ''
        },
        pubType: {
            type: String,
            default: ''
        }
    },
    data() {
        const limitNumber  = (rule, v, callback) => {
            let value = Number(v)
            if (!value) {
                return callback(new Error('比赛轮数不能为0'));
            }else if(value < 0){
                console.log(value)
                return callback(new Error('比赛轮数应大于0'))
            }else  {
                callback()
            }
        }
        return {
            ruleForm: {                
                rankList: [],
                grade: '否',
                number: 3,
                maxNumber: 3,
                winScore: 2,
                equalScore: 1,
                loseScore: 0,
                gradeScore: 17,
                gradeNumber: 4,
                groupRank: '1',
            },
            matchType: '',    
            singleRankList: [],
            doubleRankList: [],
            pubRankList: [],
            checkList: [],
            arrangeRuleList: [],
            comeRuleList: [],
            rankListName: '',
            groupRankList: [],
            rules: {
                winScore:[
                    { required: false, message: '请输入胜得分', trigger: 'blur' },
                ],
                loseScore:[
                    { required: false, message: '请输入负得分', trigger: 'blur' },
                ],
                equalScore:[
                    { required: false, message: '请输入平得分', trigger: 'blur' },
                ],
                number: [
                    { required: true, validator: limitNumber, trigger: 'blur' },
                ],
                maxNumber: [
                    { required: false, message: '请输入最大升级数', trigger: 'blur' },
                ],
                grade: [
                    { required: false, message: '请输入倒扣级数', trigger: 'blur' },
                ],
                gradeScore: [
                    { required: false, message: '请输入对方弃权级差得分', trigger: 'blur' },
                ],
                gradeNumber: [
                    { required: false, message: '请输入升级数', trigger: 'blur' },
                ],
                rankList:[
                    { required: true, message: '请选择排名方法', trigger: 'change' },
                ],
                comeRule: [
                    { required: true, message: '请选择编排规则', trigger: 'change' },
                ]
            },
            isSetting: false,
            pubTitle: '',
           
        }
    },
    created() {
        this.publishId = this.pubId

    },
    mounted() {        
        this.getEventType()     
        if(this.pubType === '1'){            
            this.getSingleRank()
        }else{
            this.getDoubleRank()
        }        
        this.getComeRuleList()
        this.getGroupRankList()
        setTimeout(()=>{
            this.getQuery()
            this.getRound()
        },100)  
    },
    methods: {
        // 获取赛事设置
        getQuery(){
            let params = {
                opcode: this.$code.PubSettingQuery,
                i_serial_mark: this.pubId
            }
            this.$api.requestAPI(params).then(res=>{
                let {winScore, loseScore, equalScore, number,
                maxNumber, grade, gradeNumber, gradeScore, rankList, comeRule} = this.ruleForm
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let list = result.map(item=>{                        
                        return{
                            winScore: 2,
                            equalScore: 1,
                            loseScore: 0,
                            number: item['轮数'],
                            maxNumber: 3,
                            grade: '否',
                            gradeNumber: 4,
                            gradeScore: 17,
                            rankList: item['排名'] === null? [] : (item['排名']).split(','),
                            comeRule: item['编排'],
                            groupRank: item['团体排名'].toString()
                        }
                    })     
                    if(list[0].comeRule){
                        this.ruleForm = { ...list[0]}
                        if(list[0].rankList){
                            this.selectRank(list[0].rankList)
                        }
                    }    
                    // console.log(list[0].comeRule,'规则')
                    if(list[0].comeRule){
                        this.isSetting = true
                    }else{
                        this.isSetting = false

                    }      
                }
            })
        },
        getRound(){
            let params = {
                opcode: this.$code.PublishQuery,
                i_serial_mark: this.publishId,
                c_status: '',
                v_type: '',
                v_theme: '',
                start_date: '',
                end_date: '',
                pagesize: 10,
                page: 1,
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable[0]
                    this.pubTitle = result['主题'],
                    this.ruleForm.number = result['轮数']
                }
            })
        },
         // 获取赛事类型
         getEventType(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 13,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    let arr = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                    this.matchType = (arr.filter(i=>i.value===this.pubType))[0].label
                }
            })
        },
        // 赛事双人排名
        getDoubleRank(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 21,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.pubRankList = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                }
            })
        },
         // 单人双人排名
         getSingleRank(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 22,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.pubRankList = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                }
            })
        },
         // 编排规则 相碰
         getComeRuleList(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 23,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.comeRuleList = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                    
                }
            })
        },
         // 获取团体排名 设置数据
         getGroupRankList(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 106,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.groupRankList = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })                    
                }
            })
        },
        submit(formName){
            this.$refs[formName].validate((valid) => {    
                if(valid){                    
                    if(this.isSetting){
                        this.$alert('您已经设置过了,确定修改吗', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'  
                        }).then(() => {
                            this.handleSubmit()
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });          
                        });
                        return false
                    }else{
                        this.handleSubmit()
                    }   
                }else{
                    console.log('error submit!!');
                    return false;
                }
            })                   
        },
        handleSubmit(){
            let {winScore, loseScore, equalScore, number,
                maxNumber, grade, gradeNumber, gradeScore, rankList, comeRule,groupRank} = this.ruleForm
            
            let params = {
                opcode: this.$code.PubSettingCode,
                i_serial_mark: this.publishId,
                v_opentrust_ranking: rankList.join(','),
                v_opentrust_layout: comeRule,
                i_round: number,
                i_win:  winScore,
                i_lose: loseScore,
                i_draw: equalScore,
                i_ascending_series_max: maxNumber,
                v_deduct_series: grade,
                i_other_waiver_score: gradeScore,
                i_other_waiver_series: gradeNumber,
                v_group_ranking: groupRank,//团体排名
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('设置成功')
                }else{
                    this.$message.error(res.Message)
                }
            })
        },  
        selectRank(a){
            let list = this.pubRankList
            let arr = []
            for(const i of a){
                let b = list.filter(k=> i === k.value)
                arr.push(
                    b[0].label
                )
            }
            this.rankListName = arr.join('，')            
        }, 
    }
}
</script>
<style lang='scss' scoped>
.grade-score >>> .el-form-item__label {
    width: 150px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/setting/components/matchSetting.vue